module.exports = __webpack_public_path__ + "img/KSC09171.31135faa.jpg";